export default "__VITE_ASSET__DGOb4KGR__"